import { Injectable } from '@angular/core';
import { DentalReferralForm, PCPReferral } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctions {
  public compare(
    a: string | number | Date | boolean | null,
    b: string | number | Date | boolean | null,
    isAsc: boolean
  ): number {
    // Handle null values
    if (a === null && b === null) return 0;
    if (a === null) return isAsc ? -1 : 1;
    if (b === null) return isAsc ? 1 : -1;

    // Special handling for booleans
    if (typeof a === 'boolean' && typeof b === 'boolean') {
      if (a === b) return 0;
      // false is considered less than true
      return (a === false ? -1 : 1) * (isAsc ? 1 : -1);
    }

    // Default comparison for strings, numbers, and Dates
    if (a < b) return isAsc ? -1 : 1;
    if (a > b) return isAsc ? 1 : -1;
    return 0;
  }



  public isPCPReferral(referral: DentalReferralForm): referral is PCPReferral {
    return (referral as PCPReferral).guardianName !== undefined; //this should be something unique to a pcp referral
  }

  public toLocalDate(dateValue: Date | string | null): Date | null {
    if (!dateValue) return null;

    if (typeof dateValue === 'string') {
      // Expected format: YYYY-MM-DD
      const [year, month, day] = dateValue.split('-').map(Number);
      return new Date(year, month - 1, day); // Local midnight
    }

    // If it's already a Date object, normalize it
    return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
  }


}

